package dev.codetwister.ctdev

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@Composable
internal fun FooterNote(
    modifier: Modifier = Modifier,
) {
    Text(
        modifier = modifier,
        text = "\u00A9 2026 Code Twister. All rights reserved.",
        fontSize = 13.sp,
        color = TextFooter,
        textAlign = TextAlign.Center,
    )
}

